import classNames from "classnames";
import {
  TWebsiteBuilderSection,
  websiteBuilderGetSectionVisibility,
} from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";
import React from "react";
import { useAppSelector } from "hooks/redux";
import { IWebsiteBuilderRoot } from "../../../../nodes/root/websiteBuilderRoot";
import { TWebsiteBuilderSectionViewHighlight } from "./WebsiteBuilderSectionView";
import { WEBSITE_BUILDER_Z_LAYERS } from "../../../../utility/websiteBuilderZLayers";
import { useWebsiteBuilderSectionMetadata } from "../../../../hooks/sectionMetadata/useWebsiteBuilderSectionMetadata";

interface ISectionHighlightTitleProps {
  highlight: TWebsiteBuilderSectionViewHighlight;
  node: TWebsiteBuilderSection;
  root: IWebsiteBuilderRoot;
}

export function SectionHighlightTitle(props: ISectionHighlightTitleProps) {
  const { highlight, node, root } = props;

  const { type } = node.section;

  const sectionMetadata = useWebsiteBuilderSectionMetadata();

  const deviceView = useAppSelector(store => store.websiteBuilderStore.editor.deviceView);
  const header = useAppSelector(store => store.websiteBuilderStore.editor.header);

  const firstVisibleMainSection = root.children.find(child => child.section.visibility[deviceView]);

  const insetTitle = type === "header" || (deviceView === "desktop" && !websiteBuilderGetSectionVisibility(header, root).desktop && (
    firstVisibleMainSection != null ? firstVisibleMainSection.id === node.id : type === "footer"
  ));

  return (
    <>
      {highlight !== "none" && (
        <div
          className={classNames("website-builder-section-highlight-title", {
            "section-highlight-title-weak-highlight": highlight === "weak",
            "section-highlight-title-strong-highlight": highlight === "strong",
            "section-highlight-title-bottom": insetTitle,
            "section-highlight-title-top": !insetTitle,
          })}
          style={{
            zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEditorUI,
          }}
        >
          {sectionMetadata[type].title}
        </div>
      )}
    </>
  );
}
